import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import classNames from "classnames";
import styles from "../styles/entity-stats-widget.module.scss";
import {ErrorBoundaryWrapper} from "../../../core/components/error-boundary/error-boundary-wrapper";

const EntityWidgetAsyncComponent = AsyncComponent(async () => import('./entity-stats-widget' /* webpackChunkName: "entity-stats-widget" */ ));

export const EntityStatsWidgetAsync = (props) => {
  return <ErrorBoundaryWrapper isMandatory={!props.isPreview}>
    <React.Suspense fallback={<div className={classNames(styles.placeholder, {[styles.preview]: props.isPreview}, props.className)}/>}>
      <EntityWidgetAsyncComponent {...props}/>
    </React.Suspense>
  </ErrorBoundaryWrapper>
};
